/** @jsxImportSource @emotion/react */
import { ROUTES } from '@sportninja/common/constants/app'
import { t } from '@sportninja/common/i18n'
import React, { useRef, useState } from 'react'
import { connect } from 'react-redux'
import {
  getHockeySport,
  getSoccerSport,
} from '@sportninja/common/selectors/types'
import GeneratePluginModal from 'src/components/GeneralPluginModal'
import { NewModal } from 'src/components/NewModal'
import OrganizationModal from 'src/components/OrganizationModal'
import CreateCompetitionWizard from 'src/features/competition/wizard/CreateCompetitionWizard'
import Page from '../../components/Page'
import ScheduleList from '../Schedules/ScheduleList'
import OrgList from '../Orgs/OrgList'
import TeamList from '../Teams/TeamList'

const Following = ({ hockeySport, soccerSport }) => {
  const [competitionsCount, setCompetitionsCount] = useState('')
  const [organizationsCount, setOrganizationsCount] = useState('')
  const [teamsCount, setTeamsCount] = useState('')

  const generatePluginTagModalRef = useRef(null)
  const [selectedItem, setSelectedItem] = useState(null)
  const [organizationModalOpen, setOrganizationModalOpen] = useState(false)
  const [organization, setOrganization] = useState(null)

  // Clone wizard — opened from a schedule row's "Clone Competition" action.
  const [cloneWizardOpen, setCloneWizardOpen] = useState(false)
  const [cloneWizardOrgId, setCloneWizardOrgId] = useState(null)
  const [cloneInitialSchedule, setCloneInitialSchedule] = useState(null)

  const onCloneCompetition = (schedule) => {
    setCloneWizardOrgId(schedule.organization?.id ?? null)
    setCloneInitialSchedule({
      id: schedule.id,
      name_full: schedule.name_full,
      starts_at: schedule.starts_at,
      ends_at: schedule.ends_at,
      is_registration_schedule: schedule.is_registration_on,
      competition_type: schedule.competition_type,
    })
    setCloneWizardOpen(true)
  }

  const onClickWebPluginOnScheduleList = (schedule) => {
    setSelectedItem(schedule)
    generatePluginTagModalRef?.current?.openModal()
  }

  const onClickWebPluginOnTeamList = (team) => {
    setSelectedItem(team)
    generatePluginTagModalRef?.current?.openModal()
  }

  const pages = [
    {
      to: `${ROUTES.FOLLOWING.ORGANIZATIONS}`,
      text: `${t('common:organization_plural', { count: 2 })} ${
        organizationsCount ? `(${organizationsCount})` : ''
      }`,
      component: (
        <OrgList
          key='organizations-following'
          slug='/favorites/organizations'
          setCount={setOrganizationsCount}
          setInitialState={setOrganization}
          onEditOrg={() => {
            setOrganizationModalOpen(true)
          }}
          isFavorites={true}
        />
      ),
    },
    {
      to: `${ROUTES.FOLLOWING.COMPETITIONS}`,
      text: `${t('common:competition_plural', { count: 2 })} ${
        competitionsCount ? `(${competitionsCount})` : ''
      }`,
      component: (
        <ScheduleList
          key='competitions-following'
          slug='/favorites/schedules'
          setCount={setCompetitionsCount}
          alwaysListArchived={false}
          onClickWebPluginOnScheduleList={onClickWebPluginOnScheduleList}
          onCloneCompetition={onCloneCompetition}
        />
      ),
    },
    {
      to: `${ROUTES.FOLLOWING.TEAMS}`,
      text: `${t('common:team_plural', { count: 2 })} ${
        teamsCount ? `(${teamsCount})` : ''
      }`,
      component: (
        <TeamList
          key='teams-following'
          slug='/favorites/teams'
          setCount={setTeamsCount}
          soccerSport={soccerSport}
          hockeySport={hockeySport}
          onClickWebPluginOnTeamList={onClickWebPluginOnTeamList}
          isFavorites={true}
        />
      ),
    },
  ]

  const BASE_ROUTE = ROUTES.FOLLOWING.ROOT

  return (
    <>
      <Page
        displayMobileActions={false}
        baseRoute={BASE_ROUTE}
        pages={pages}
        baseTitle='Following'
        title='Favorites'
        isOrgsPage={true}
        hideBreadcrumbs={true}
      />
      <OrganizationModal
        isFormOpen={organizationModalOpen}
        setIsFormOpen={setOrganizationModalOpen}
        organization={organization}
        setOrganization={setOrganization}
        refresh={() => {
          // Refresh logic if needed
        }}
      />
      <NewModal
        ref={generatePluginTagModalRef}
        shouldCloseOnOverlayClick={false}
      >
        <GeneratePluginModal
          onPressClose={() => {
            generatePluginTagModalRef?.current?.closeModal()
            setSelectedItem(null)
          }}
          scheduleId={selectedItem?.id}
          isOrganization={false}
          isTeam={false}
        />
      </NewModal>
      {cloneWizardOrgId ? (
        <CreateCompetitionWizard
          isOpen={cloneWizardOpen}
          orgId={cloneWizardOrgId}
          cloneInitialSchedule={cloneInitialSchedule}
          onClose={() => {
            setCloneWizardOpen(false)
            setCloneInitialSchedule(null)
            setCloneWizardOrgId(null)
          }}
          onSkipToLegacy={() => setCloneWizardOpen(false)}
        />
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    hockeySportId: getHockeySport(state)?.id,
    soccerSportId: getSoccerSport(state)?.id,
    hockeySport: getHockeySport(state),
    soccerSport: getSoccerSport(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Following)
